// extracted by mini-css-extract-plugin
module.exports = {"previewHeader":"style_previewHeader__1rP3iDyFX-kaHE3zMneRTW","tableStyle":"style_tableStyle__BAXa-j_2bYKhKJI9-FBHg"};